import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import ModalBase from "./ModalBase";
import { validateInputs } from "../../utils/inputValidations";
import { IValidation } from "../../interfaces/form";
import { ERRORS_MESSAGES } from "../../utils/constants";
import {
  ICredentialsOcasa,
  ICredentialsOcasaErrors,
  ICredentialsOcasaPayload,
  IProductAgrement,
} from "../../interfaces/configuration";
import CredentialsOcasa from "../forms/CredentialsOcasa";
import { ICredentialsModal } from "../../interfaces/modal";
import ConfirmChangesCredentials from "../configuration/ConfirmChangesCredentials";
import GenericForm from "../GenericForm";

const {
  cuitRequired,
  cuitInvalid,
  reverseOnlyNumbers,
  doorToDoorOnlyNumbers,
  doorToDoorRequired,
  externalClientIdRequired,
  externalClientSecretRequired,
} = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "user_cuit",
    type: "required",
    message: cuitRequired,
  },
  {
    id: "user_cuit",
    type: "cuit",
    message: cuitInvalid,
  },
  {
    id: "door_to_door",
    type: "required",
    message: doorToDoorRequired,
  },
  {
    id: "door_to_door",
    type: "only-numbers",
    message: doorToDoorOnlyNumbers,
  },
  {
    id: "reverse_logistics",
    type: "required",
    message: reverseOnlyNumbers,
  },
  {
    id: "reverse_logistics",
    type: "only-numbers",
    message: reverseOnlyNumbers,
  },

  {
    id: "external_client_id",
    type: "required",
    message: externalClientIdRequired,
  },
  {
    id: "external_client_secret",
    type: "required",
    message: externalClientSecretRequired,
  },
];

const getDataFromAgreement = ({
  service_code,
  end_date,
  name,
}: IProductAgrement) => {
  switch (name) {
  case "DOOR_TO_DOOR":
    return { door_to_door_end_date: end_date, door_to_door: service_code };
  case "REVERSE_LOGISTICS":
    return { reverse_end_date: end_date, reverse: service_code };
  default:
    return {};
  }
};
const getProductAgreement = (product_agreement: IProductAgrement[] | undefined) => {
  let agreement_data = {};
  product_agreement?.forEach((agreement) => {
    agreement_data = { ...agreement_data, ...getDataFromAgreement(agreement) };
  });
  return agreement_data;
};

const CredentialsOcasaModal = ({
  open,
  onClose,
  carrier,
  handleChangeOfConfig,
}: ICredentialsModal) => {
  const { product_agreement, ...restCredentials } = (carrier.credentials ||
    {}) as ICredentialsOcasaPayload;
  const initialValues = {
    ...restCredentials,
    ...getProductAgreement(product_agreement),
  };
  const [values, setValues] = useState(initialValues as ICredentialsOcasa);
  const [errors, setErrors] = useState({} as ICredentialsOcasaErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(values, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {

      const { ...restValues } = values;

      handleChangeOfConfig({
        _id: carrier._id,
        name: carrier.name,
        disabled: carrier.disabled,
        credentials: {
          ...restValues,
        },
      });
      onClose();
    }
  };
  return (
    <ModalBase open={open} handleClose={onClose} maxWidth="md">
      <Grid container>
        <Typography className="f-s-20 m-b-20">
          Ingresa los datos de tu contrato con Ocasa
        </Typography>

        <GenericForm onSubmit={handleSubmit}>
          <CredentialsOcasa
            values={values}
            setValues={setValues}
            errors={errors}
          />
        </GenericForm>

        <ConfirmChangesCredentials
          onClose={onClose}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </ModalBase>
  );
};

export default CredentialsOcasaModal;
